<div>
    <div class="rp-input-wrapper">
        <input #searchInputModel="ngModel" [(ngModel)]="searchInput" type="text" class="form-field" name="searchInput"
            placeholder="Select contacts to assign" (focus)="onFocus()" />
        <button type="button" class="list-button" (click)="onFocusButton()"></button>
    </div>

    @if(isListOpen()){
    <div class="rp-selection-wrapper">
        <ul id="rpSelection">
            @for (contact of searchContact(); track $index){
            <li (click)="sendContactToParent(contact)" [ngClass]="{'active-contact': checkSelectedRp(contact), 'selected': checkSelectedRp(contact)}">
                <div class="item-name-box">
                    <span class="initials" [style.backgroundColor]="contact.bgColor">{{ getLetters(contact) }}</span>
                    <span class="item-name">{{ contact.name }} <span class="item-name" *ngIf="isCurrentUser(contact)">(You)</span></span>
                </div>
                @if (checkSelectedRp(contact)) {
                <svg class="checkbox" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960"
                    width="24px" fill="#FFFFFF">
                    <path
                        d="m424-312 282-282-56-56-226 226-114-114-56 56 170 170ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z" />
                </svg>
                }@else {
                <svg class="checkbox" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960"
                    width="24px" fill="#000000">
                    <path
                        d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Z" />
                </svg>
                }
            </li>
            }
        </ul>
    </div>

    }
</div>